import { useEffect } from "react";

/**
 * Floating "PDF" button (demo: Today's Update, Trends) — saves the page as a
 * PDF through the browser's print dialog ("Save as PDF"). The print styles in
 * styles.css drop the menu, header and buttons and let the page run to full
 * length; the document title becomes the default file name.
 */
export function PdfButton({ fileName, landscape }: { fileName: string; landscape?: boolean }) {
  useEffect(() => {
    if (!landscape) return;
    const s = document.createElement("style");
    s.textContent = "@page { size: landscape; margin: 12mm; }";
    document.head.appendChild(s);
    return () => { s.remove(); };
  }, [landscape]);
  const go = () => {
    const prev = document.title;
    document.title = `${fileName} ${new Date().toISOString().slice(0, 10)}`;
    const restore = () => { document.title = prev; window.removeEventListener("afterprint", restore); };
    window.addEventListener("afterprint", restore);
    window.print();
  };
  return (
    <button className="pdf-fab no-print" onClick={go} title="Save this page as a PDF (choose Save as PDF in the print dialog)">
      <span aria-hidden>⤓</span> PDF
    </button>
  );
}
